module.exports = __webpack_public_path__ + "c0a1e912fb7158ac92f4f24605c0e3bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/Slideshow_01.jpg
// module id = 621
// module chunks = 0